import _createForOfIteratorHelper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/jacob/Documents/Github/Website-Backups/korasline.com/imroz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Circle, Constants, ExternalInteractorBase, Rectangle } from "../../../Core";
import { clamp, colorMix, colorToHsl, divMode, divModeExecute, getDistance, getRangeMax, isDivModeEnabled, isInArray, itemFromArray, rgbToHsl } from "../../../Utils";

function calculateBubbleValue(particleValue, modeValue, optionsValue, ratio) {
  if (modeValue >= optionsValue) {
    var value = particleValue + (modeValue - optionsValue) * ratio;
    return clamp(value, particleValue, modeValue);
  } else if (modeValue < optionsValue) {
    var _value = particleValue - (optionsValue - modeValue) * ratio;

    return clamp(_value, modeValue, particleValue);
  }
}

export var Bubbler = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Bubbler, _ExternalInteractorBa);

  var _super = _createSuper(Bubbler);

  function Bubbler(container) {
    _classCallCheck(this, Bubbler);

    return _super.call(this, container);
  }

  _createClass(Bubbler, [{
    key: "isEnabled",
    value: function isEnabled() {
      var container = this.container,
          options = container.actualOptions,
          mouse = container.interactivity.mouse,
          events = options.interactivity.events,
          divs = events.onDiv,
          divBubble = isDivModeEnabled("bubble", divs);

      if (!(divBubble || events.onHover.enable && mouse.position || events.onClick.enable && mouse.clickPosition)) {
        return false;
      }

      var hoverMode = events.onHover.mode;
      var clickMode = events.onClick.mode;
      return isInArray("bubble", hoverMode) || isInArray("bubble", clickMode) || divBubble;
    }
  }, {
    key: "reset",
    value: function reset(particle, force) {
      if (!(!particle.bubble.inRange || force)) {
        return;
      }

      delete particle.bubble.div;
      delete particle.bubble.opacity;
      delete particle.bubble.radius;
      delete particle.bubble.color;
    }
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var options, events, onHover, onClick, hoverEnabled, hoverMode, clickEnabled, clickMode, divs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = this.container.actualOptions, events = options.interactivity.events, onHover = events.onHover, onClick = events.onClick, hoverEnabled = onHover.enable, hoverMode = onHover.mode, clickEnabled = onClick.enable, clickMode = onClick.mode, divs = events.onDiv;

                if (hoverEnabled && isInArray("bubble", hoverMode)) {
                  this.hoverBubble();
                } else if (clickEnabled && isInArray("bubble", clickMode)) {
                  this.clickBubble();
                } else {
                  divModeExecute("bubble", divs, function (selector, div) {
                    return _this.singleSelectorHover(selector, div);
                  });
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "singleSelectorHover",
    value: function singleSelectorHover(selector, div) {
      var _this2 = this;

      var container = this.container,
          selectors = document.querySelectorAll(selector);

      if (!selectors.length) {
        return;
      }

      selectors.forEach(function (item) {
        var elem = item,
            pxRatio = container.retina.pixelRatio,
            pos = {
          x: (elem.offsetLeft + elem.offsetWidth / 2) * pxRatio,
          y: (elem.offsetTop + elem.offsetHeight / 2) * pxRatio
        },
            repulseRadius = elem.offsetWidth / 2 * pxRatio,
            area = div.type === "circle" ? new Circle(pos.x, pos.y, repulseRadius) : new Rectangle(elem.offsetLeft * pxRatio, elem.offsetTop * pxRatio, elem.offsetWidth * pxRatio, elem.offsetHeight * pxRatio),
            query = container.particles.quadTree.query(area);

        var _iterator = _createForOfIteratorHelper(query),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var particle = _step.value;

            if (!area.contains(particle.getPosition())) {
              continue;
            }

            particle.bubble.inRange = true;
            var divs = container.actualOptions.interactivity.modes.bubble.divs;
            var divBubble = divMode(divs, elem);

            if (!particle.bubble.div || particle.bubble.div !== elem) {
              _this2.reset(particle, true);

              particle.bubble.div = elem;
            }

            _this2.hoverBubbleSize(particle, 1, divBubble);

            _this2.hoverBubbleOpacity(particle, 1, divBubble);

            _this2.hoverBubbleColor(particle, 1, divBubble);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }, {
    key: "process",
    value: function process(particle, distMouse, timeSpent, data) {
      var container = this.container,
          bubbleParam = data.bubbleObj.optValue;

      if (bubbleParam === undefined) {
        return;
      }

      var options = container.actualOptions,
          bubbleDuration = options.interactivity.modes.bubble.duration,
          bubbleDistance = container.retina.bubbleModeDistance,
          particlesParam = data.particlesObj.optValue,
          pObjBubble = data.bubbleObj.value,
          pObj = data.particlesObj.value || 0,
          type = data.type;

      if (bubbleParam === particlesParam) {
        return;
      }

      if (!container.bubble.durationEnd) {
        if (distMouse <= bubbleDistance) {
          var obj = pObjBubble !== null && pObjBubble !== void 0 ? pObjBubble : pObj;

          if (obj !== bubbleParam) {
            var value = pObj - timeSpent * (pObj - bubbleParam) / bubbleDuration;

            if (type === "size") {
              particle.bubble.radius = value;
            }

            if (type === "opacity") {
              particle.bubble.opacity = value;
            }
          }
        } else {
          if (type === "size") {
            delete particle.bubble.radius;
          }

          if (type === "opacity") {
            delete particle.bubble.opacity;
          }
        }
      } else if (pObjBubble) {
        if (type === "size") {
          delete particle.bubble.radius;
        }

        if (type === "opacity") {
          delete particle.bubble.opacity;
        }
      }
    }
  }, {
    key: "clickBubble",
    value: function clickBubble() {
      var _a, _b;

      var container = this.container,
          options = container.actualOptions,
          mouseClickPos = container.interactivity.mouse.clickPosition;

      if (!mouseClickPos) {
        return;
      }

      var distance = container.retina.bubbleModeDistance,
          query = container.particles.quadTree.queryCircle(mouseClickPos, distance);

      var _iterator2 = _createForOfIteratorHelper(query),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var particle = _step2.value;

          if (!container.bubble.clicking) {
            continue;
          }

          particle.bubble.inRange = !container.bubble.durationEnd;
          var pos = particle.getPosition(),
              distMouse = getDistance(pos, mouseClickPos),
              timeSpent = (new Date().getTime() - (container.interactivity.mouse.clickTime || 0)) / 1000;

          if (timeSpent > options.interactivity.modes.bubble.duration) {
            container.bubble.durationEnd = true;
          }

          if (timeSpent > options.interactivity.modes.bubble.duration * 2) {
            container.bubble.clicking = false;
            container.bubble.durationEnd = false;
          }

          var sizeData = {
            bubbleObj: {
              optValue: container.retina.bubbleModeSize,
              value: particle.bubble.radius
            },
            particlesObj: {
              optValue: getRangeMax(particle.options.size.value) * container.retina.pixelRatio,
              value: particle.size.value
            },
            type: "size"
          };
          this.process(particle, distMouse, timeSpent, sizeData);
          var opacityData = {
            bubbleObj: {
              optValue: options.interactivity.modes.bubble.opacity,
              value: particle.bubble.opacity
            },
            particlesObj: {
              optValue: getRangeMax(particle.options.opacity.value),
              value: (_b = (_a = particle.opacity) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 1
            },
            type: "opacity"
          };
          this.process(particle, distMouse, timeSpent, opacityData);

          if (!container.bubble.durationEnd) {
            if (distMouse <= container.retina.bubbleModeDistance) {
              this.hoverBubbleColor(particle, distMouse);
            } else {
              delete particle.bubble.color;
            }
          } else {
            delete particle.bubble.color;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "hoverBubble",
    value: function hoverBubble() {
      var container = this.container,
          mousePos = container.interactivity.mouse.position;

      if (mousePos === undefined) {
        return;
      }

      var distance = container.retina.bubbleModeDistance,
          query = container.particles.quadTree.queryCircle(mousePos, distance);

      var _iterator3 = _createForOfIteratorHelper(query),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var particle = _step3.value;
          particle.bubble.inRange = true;
          var pos = particle.getPosition(),
              pointDistance = getDistance(pos, mousePos),
              ratio = 1 - pointDistance / distance;

          if (pointDistance <= distance) {
            if (ratio >= 0 && container.interactivity.status === Constants.mouseMoveEvent) {
              this.hoverBubbleSize(particle, ratio);
              this.hoverBubbleOpacity(particle, ratio);
              this.hoverBubbleColor(particle, ratio);
            }
          } else {
            this.reset(particle);
          }

          if (container.interactivity.status === Constants.mouseLeaveEvent) {
            this.reset(particle);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "hoverBubbleSize",
    value: function hoverBubbleSize(particle, ratio, divBubble) {
      var container = this.container,
          modeSize = (divBubble === null || divBubble === void 0 ? void 0 : divBubble.size) ? divBubble.size * container.retina.pixelRatio : container.retina.bubbleModeSize;

      if (modeSize === undefined) {
        return;
      }

      var optSize = getRangeMax(particle.options.size.value) * container.retina.pixelRatio;
      var pSize = particle.size.value;
      var size = calculateBubbleValue(pSize, modeSize, optSize, ratio);

      if (size !== undefined) {
        particle.bubble.radius = size;
      }
    }
  }, {
    key: "hoverBubbleOpacity",
    value: function hoverBubbleOpacity(particle, ratio, divBubble) {
      var _a, _b, _c;

      var container = this.container,
          options = container.actualOptions,
          modeOpacity = (_a = divBubble === null || divBubble === void 0 ? void 0 : divBubble.opacity) !== null && _a !== void 0 ? _a : options.interactivity.modes.bubble.opacity;

      if (!modeOpacity) {
        return;
      }

      var optOpacity = particle.options.opacity.value;
      var pOpacity = (_c = (_b = particle.opacity) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : 1;
      var opacity = calculateBubbleValue(pOpacity, modeOpacity, getRangeMax(optOpacity), ratio);

      if (opacity !== undefined) {
        particle.bubble.opacity = opacity;
      }
    }
  }, {
    key: "hoverBubbleColor",
    value: function hoverBubbleColor(particle, ratio, divBubble) {
      var options = this.container.actualOptions;
      var bubbleOptions = divBubble !== null && divBubble !== void 0 ? divBubble : options.interactivity.modes.bubble;

      if (!particle.bubble.finalColor) {
        var modeColor = bubbleOptions.color;

        if (!modeColor) {
          return;
        }

        var bubbleColor = modeColor instanceof Array ? itemFromArray(modeColor) : modeColor;
        particle.bubble.finalColor = colorToHsl(bubbleColor);
      }

      if (!particle.bubble.finalColor) {
        return;
      }

      if (bubbleOptions.mix) {
        particle.bubble.color = undefined;
        var pColor = particle.getFillColor();
        particle.bubble.color = pColor ? rgbToHsl(colorMix(pColor, particle.bubble.finalColor, 1 - ratio, ratio)) : particle.bubble.finalColor;
      } else {
        particle.bubble.color = particle.bubble.finalColor;
      }
    }
  }]);

  return Bubbler;
}(ExternalInteractorBase);